module.exports = __webpack_public_path__ + "static/img/a077.13cf255.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a077.jpg
// module id = hBHA
// module chunks = 0